/**
 * @generated SignedSource<<e1a3934801176ba94d61257a0048fc9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NewRbGameInput = {
  currency?: string | null;
  virtualId?: number | null;
};
export type rbNewRbGameMutation$variables = {
  input: NewRbGameInput;
};
export type rbNewRbGameMutation$data = {
  readonly newRbGame: {
    readonly game: {
      readonly state: string;
      readonly gameId: string;
      readonly serverSeed: string | null;
      readonly serverSeedHash: string;
      readonly currency: string | null;
      readonly virtualId: number | null;
      readonly finalShuffle: string | null;
      readonly finalShuffleHash: string | null;
      readonly result: boolean | null;
      readonly bet: number | null;
      readonly betColor: string | null;
    };
  } | null;
};
export type rbNewRbGameMutation = {
  variables: rbNewRbGameMutation$variables;
  response: rbNewRbGameMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "NewRbGamePayload",
    "kind": "LinkedField",
    "name": "newRbGame",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RbGame",
        "kind": "LinkedField",
        "name": "game",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gameId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serverSeed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serverSeedHash",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currency",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "virtualId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "finalShuffle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "finalShuffleHash",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "result",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bet",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "betColor",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "rbNewRbGameMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rbNewRbGameMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ecfb725c9f410066de678da3190848b8",
    "id": null,
    "metadata": {},
    "name": "rbNewRbGameMutation",
    "operationKind": "mutation",
    "text": "mutation rbNewRbGameMutation(\n  $input: NewRbGameInput!\n) {\n  newRbGame(input: $input) {\n    game {\n      state\n      gameId\n      serverSeed\n      serverSeedHash\n      currency\n      virtualId\n      finalShuffle\n      finalShuffleHash\n      result\n      bet\n      betColor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "07353609496b67c682965c5180438f83";

export default node;
